module.exports = __webpack_public_path__ + "img/P12-zh.88371263.png";